import React from 'react';
import PropTypes from 'prop-types';

const AboutHeader = ({ text }) => (
    <div className="about-titles" dangerouslySetInnerHTML={ { __html: text } }/>
);

AboutHeader.propTypes = {
    text: PropTypes.string.isRequired
};

export default AboutHeader;



// WEBPACK FOOTER //
// ./src/components/content/about/AboutHeader.jsx